import { FILTERS } from '@/config/filters';
import { findPropertyTypeByUrlParam } from '@/utils/propertyTypes.js';

export function useFilters() {
  const { t } = useI18n();
  const route = useRoute();

  const routePropertyType = route?.params?.propertyType;
  const routeFilter = route?.params?.filter;

  const propertyTypeObj = findPropertyTypeByUrlParam(routePropertyType);

  const getTranslatedFiltersList = computed(() => {
    return FILTERS.reduce((prevFilters, filter) => {
      prevFilters.push({
        ...filter,
        transcode_text: t(filter.transcode_text),
        transcode_title: t(filter.transcode_title),
        transcode_alttext: t(filter.transcode_alttext, {
          PROPERTYTYPES: t(propertyTypeObj.transcode),
          ACTIVEFILTER: t(filter.transcode_text),
        }),
      });
      return prevFilters;
    }, []);
  });

  const getCurrentFilter = function () {
    if (!routeFilter) {
      return null;
    }

    return FILTERS.find((filter) => t(filter.slug) === routeFilter) || null;
  };

  return {
    useFilter: {
      getTranslatedFiltersList,
      getCurrentFilter,
    },
  };
}
